import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from 'core/common/entities';
import {
  submitSupportFormFailed,
  submitSupportFormPending,
  submitSupportFormSucceed,
} from './actions';
import { supportInitialState } from './state';

export const supportReducer = createReducer(supportInitialState, (builder) => {
  builder
    .addCase(submitSupportFormPending, (state) => {
      state.loadingStatus = LoadingStatuses.PENDING;
    })
    .addCase(submitSupportFormSucceed, (state) => {
      state.loadingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(submitSupportFormFailed, (state) => {
      state.loadingStatus = LoadingStatuses.FAILED;
    });
});
